<top-banner variant="custom">
    <h2 class="title mb-3">Site Types</h2>
    <button type="button" (click)="toggleCreateSiteTypeModal()" class="btn color_blue-btn btn-round">
      <i class="fas fa-plus"></i>
      &nbsp;
      <strong>CREATE NEW SITE TYPE</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="siteTypes" selectionMode="single" [(selection)]="selectedSiteType" (onRowSelect)="onRowSelect($event)">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Id</th>
                    <th>Name</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-type>
                  <tr [pSelectableRow]="type">
                    <td>{{ type.id }}</td>
                    <td>{{ type.name }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="2">No site types found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="New Site Type" [(visible)]="createSiteTypeModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="createSiteTypeForm" (ngSubmit)="onCreateSiteTypeFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="" />
        </div>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="createSiteTypeModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onCreateSiteTypeFormSubmit()" [disabled]="!createSiteTypeForm.valid" class="my-2 btn btn-round btn-sm btn-success">Create</button>
  </p-footer>
</p-dialog>

<p-dialog header="Edit Site Type" [(visible)]="editSiteTypeModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="editSiteTypeForm" (ngSubmit)="onEditSiteTypeFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="editSiteTypeModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onEditSiteTypeFormSubmit()" [disabled]="!editSiteTypeForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>
